import React, { useEffect } from "react";
import { CardGroup, Container, Card } from "react-bootstrap";
import Fade from "react-reveal/Fade";

const Blogs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container
      id="blogs"
      className="my-5 py-4"
      style={{ backgroundColor: "black", color: "white" }}
    >
      <Fade bottom>
        <p className="text-white text-center fw-bold fs-1">My Blogs</p>
        <CardGroup className="pb-5 px-2">
          <Card className="pb-2 mx-2">
            <Card.Img
              variant="top"
              src="https://miro.medium.com/max/875/0*oZzFZRTXDhnoW3F4.png"
              height="250px"
              width="250px"
            />
            <Card.Body>
              <Card.Title>All About Javascript Array Methods</Card.Title>
              <Card.Text>
                Today’s blog is all about Javascript array methods. There are
                different types of array methods in Javascript, and those
                methods are built-in to Javascript. We can use every method for
                various purposes. So Let’s Start.
              </Card.Text>
            </Card.Body>
            <Card.Footer>
              <small className="text-muted">
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  rel="noreferrer"
                  href="https://medium.com/@tahmid231/all-about-javascript-array-methods-f2af381156fd"
                  target="_blank"
                >
                  Read More
                </a>
              </small>
            </Card.Footer>
          </Card>
          <Card className="pb-2 mx-2">
            <Card.Img
              variant="top"
              src="https://miro.medium.com/max/875/0*uxWdolwzBw4MQ3u7"
              height="250px"
              width="250px"
            />
            <Card.Body>
              <Card.Title>All About CSS Flexbox</Card.Title>
              <Card.Text>
                CSS flexbox is a one-dimensional layout model which is used to
                arrange any HTML elements or items using rows or columns. We can
                use flex in the parent element of the child.
              </Card.Text>
            </Card.Body>
            <Card.Footer>
              <small className="text-muted">
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  rel="noreferrer"
                  href="https://medium.com/@tahmid231/crack-the-css-flexbox-5a6eab8de094"
                  target="_blank"
                >
                  Read More
                </a>
              </small>
            </Card.Footer>
          </Card>
          <Card className="pb-2 mx-2">
            <Card.Img
              variant="top"
              src="https://miro.medium.com/max/875/0*K3vfQdcuLeqhZ4lv.png"
              height="250px"
              width="250px"
            />
            <Card.Body>
              <Card.Title>The Basic Concept Of Mongoose</Card.Title>
              <Card.Text>
                Mongoose is a Node.js based Object Data Modeling (ODM) library
                that is woked with MongoDB. In javascript, we think of
                everything as an object, and it is easy to work with an object
                in javascript.
              </Card.Text>
            </Card.Body>
            <Card.Footer>
              <small className="text-muted">
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  rel="noreferrer"
                  href="https://medium.com/@tahmid231/the-basic-concept-of-mongoose-27a1ede999ef"
                  target="_blank"
                >
                  Read More
                </a>
              </small>
            </Card.Footer>
          </Card>
        </CardGroup>
      </Fade>
    </Container>
  );
};

export default Blogs;
